import React from "react";
import styles from "./DataTable.module.css";

/**
 * Tabela genérica de dados tabulares.
 *
 * @param {{ headers: string[], rows: any[][], emptyMsg?: string }} props
 */
export default function DataTable({ headers, rows, emptyMsg = "Sem dados no período" }) {
  if (!rows?.length) return <p className={styles.emptyMsg}>{emptyMsg}</p>;
  return (
    <div className={styles.tableWrapper}>
      <table className={styles.table}>
        <thead>
          <tr>
            {headers.map((h) => (
              <th key={h}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {/* key por índice é intencional: DataTable recebe rows já ordenadas pelo pai */}
          {rows.map((row, i) => (
            <tr key={i}>
              {row.map((cell, j) => (
                <td key={j}>{cell ?? "—"}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
